import ContentLoader from "react-content-loader";
import { useMediaQuery } from "react-responsive";
import { Color } from "../../enums/Color";
import { merge } from "react-merge";

const styles = {
    mobile: {
        wrapper: {
            width: "85vw",
            margin: "0 auto"
        },
        card: {
            width: "100%",
            height: "44.15vw",
            backgroundColor: Color.White
        }
    },
    desktop: {
        wrapper: {
            width: "25vw"
        },
        card: {
            height: "13vw"            
        }
    }
};

export const InvoicePaymentLoader: React.FC = () => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    var loaderStyles = styles.mobile;

    if (!isMobile) {
        let extendStyles = merge(styles.mobile, styles.desktop);
        loaderStyles = extendStyles;
    }

    return (
        <div style={loaderStyles.wrapper}>
            <div style={loaderStyles.card}>
                <ContentLoader
                    speed={1}
                    width={"100%"}
                    height={loaderStyles.card.height}
                    backgroundColor={Color.LoaderBackground}
                    foregroundColor={Color.LoaderForeground}
                >
                    {isMobile ? <>
                        <rect x="0%" y="0%" rx="5" ry="5" width="33.62%" height="17.89%"/>
                        <rect x="55.40%" y="0%" rx="5" ry="5" width="43.62%" height="17.89%"/>
                        <rect x="0%" y="34%" rx="5" ry="5" width="100%" height="19.25%"/>
                        <rect x="4.2%" y="64%" rx="5" ry="5" width="88.71%" height="22.18%"/>
                        <rect x="4.2%" y="88.90%" rx="5" ry="5" width="88.71%" height="10.58%"/>
                    </> 
                    : <>
                        <rect x="0%" y="0%" rx="5" ry="5" width="33.62%" height="17.89%"/>
                        <rect x="55.40%" y="0%" rx="5" ry="5" width="43.62%" height="17.89%"/>
                        <rect x="0%" y="34%" rx="5" ry="5" width="100%" height="19.25%"/>
                        <rect x="4.2%" y="64%" rx="5" ry="5" width="88.71%" height="22.18%"/>
                        <rect x="4.2%" y="88.90%" rx="5" ry="5" width="88.71%" height="10.58%"/>
                    </>}                     
                </ContentLoader>
            </div>
        </div>
    );
}